import React from "react";

class Speaker3 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "Keynote Speakers - 21st International Conference on Information Technology and Applications (ICITA)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Keynote Speaker</h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    <div className="col-xl-12 col-md-12">
                      <img
                        src={require("../assets/img-comm/celio.png")}
                        alt=""
                        width="200"
                        height="260"
                      />
                      <h4>Professor Célio Gonçalo Marques</h4>

                      <div className="organiser_intro mt-2 col-md-12">
                        <div className="col-md-12">
                          <p align="center">
                            <i>
                              {/* Director of Centro ALGORITMI, Director of the
                              Doctoral Program in Biomedical Engineering
                              Department of Informatics / Centro ALGORITMI,
                              School of Engineering, University of Minho,
                              Portugal */}
                            </i>
                          </p>
                        </div>
                      </div>
                      <br></br>
                      <div className="intro_left_content text_left">
                        <p align="left">
                           Professor of the Information and Communication
                          Technologies Department of the Polytechnic University
                          of Tomar (UPTomar). Vice-President of UPTomar,
                          Director of the Laboratory of Pedagogical Innovation
                          and Distance Learning (LIED) and responsible for the
                          Research and Innovation Support Office (GAII). General
                          Secretary of the European Universities Alliance:
                          KreativEU and member of the National Council for
                          Pedagogical Innovation in Higher Education: CNIPES
                          (Portugal). Has a degree in Computer Science and
                          Management, a MSc in Educational Multimedia
                          Communication, a post-graduation in e-Learning
                          Techniques and Contexts, and a Ph.D. in Educational
                          Sciences, with a specialization in Educational
                          Technology. Integrated researcher of TECHN&ART (R&D
                          unit) of which he was director from October 2018 to
                          January 2024, and collaborator researcher of the
                          Educational Technology Laboratory (University of
                          Coimbra), Center for Administration and Public Policy
                          (University of Lisbon) and Grigore Gafencu Research
                          Center for the History of International Relations and
                          Cultural Heritage (Valahia University of Târgoviste).
                          Expertise research fields include educational
                          technology, ICT for cultural heritage, and public
                          policies. Member of the Association for the Promotion
                          and Development of the Information Society (APDSI),
                          Metared Portugal, Europeana Network Association, NAU -
                          Online Teaching and Training for Large Audiences,
                          among others. Has worked on projects related to
                          computer science in education and as a consultant with
                          several companies. Author of several national and
                          international publications, and with active
                          participation in organizing committees of various
                          scientific and technical events.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Speaker3;
